import { render, staticRenderFns } from "./ChuyouRemenLuxian.vue?vue&type=template&id=053a1d2c&scoped=true&"
import script from "./ChuyouRemenLuxian.vue?vue&type=script&lang=js&"
export * from "./ChuyouRemenLuxian.vue?vue&type=script&lang=js&"
import style0 from "./ChuyouRemenLuxian.vue?vue&type=style&index=0&id=053a1d2c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053a1d2c",
  null
  
)

export default component.exports